import styled from "styled-components";

import { Badge, FlexRow } from "@similarweb/ui-components";

export const AddonsCartButtonWrapper = styled("div")`
    position: relative;
`;

export const AddonsCartButtonTooltipFlexItem = styled(FlexRow)`
    margin-left: 10px;
    align-items: center;
    gap: 5px;
`;

export const AddonsCartBadgeStyled = styled(Badge)`
    position: absolute;
    top: 0;
    right: 0;
`;
